var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 48 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004F8B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.947 14.284L19.337.228h3.82l-2.39 14.056h-3.82M34.622.574c-.757-.285-1.943-.59-3.424-.59-3.775 0-6.434 1.906-6.457 4.639-.02 2.02 1.899 3.146 3.348 3.818 1.487.69 1.987 1.129 1.98 1.744-.01.942-1.188 1.373-2.286 1.373-1.529 0-2.341-.213-3.596-.738l-.492-.224-.536 3.147c.892.392 2.542.732 4.255.75 4.016 0 6.623-1.885 6.653-4.803.014-1.598-1.004-2.815-3.208-3.818-1.335-.65-2.153-1.085-2.144-1.743 0-.584.692-1.209 2.188-1.209a7.028 7.028 0 012.859.539l.342.162.518-3.047m9.796-.332h-2.952c-.914 0-1.598.25-2 1.165L33.792 14.29h4.012s.656-1.732.804-2.112l4.893.005c.114.492.465 2.107.465 2.107h3.545L44.418.242m-4.71 9.06c.316-.81 1.522-3.93 1.522-3.93-.023.038.313-.813.506-1.341l.259 1.212.884 4.058h-3.171M13.743.239l-3.74 9.585-.399-1.948C8.908 5.63 6.74 3.197 4.314 1.98l3.42 12.292 4.041-.004L17.79.238h-4.047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.533.23H.373L.324.522c4.793 1.164 7.964 3.975 9.28 7.354l-1.339-6.46C8.034.527 7.363.262 6.533.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.0d108aebe2a35c1bbe4eff303c904dab.svg";
export { ForwardRef as ReactComponent };